<template>
  <header class="app-header-root" :class="{ 'app-header-root-bottom': getGameView }">
    <div class="app-header" :class="{ 'app-header--is-login': isLoggedIn }">
      <layout-header-game-mobile v-if="getGameView" />

      <layout-header-default-mobile v-else />
    </div>
  </header>
</template>

<script setup lang="ts">
  import { updateCssVars } from '@skeleton/utils/updateCssVars';

  const gameStore = useIsGamePlayed();
  const { getGameView } = storeToRefs(gameStore);
  const { isLoggedIn } = storeToRefs(useProfileStore());

  onMounted(async () => {
    await nextTick();
    updateCssVars();
  });
</script>

<style src="~/assets/styles/components/layout/header-mobile.scss" lang="scss" />
